import { gql } from '@parkchirp/api-client';

export const GET_USER_HISTORY_V2 = gql`
    query getUserHistory(
        $userId: String!
    ) {
        getUserHistory(
            userId: $userId
        ) {
            id
            userAction
            userActionDescription
            resourceAction
            resourceType
            time
        }
    }
`;
